import DownloadPdfRequestModelBase from '../_generated/modelBases/download-pdf-request-model-base';

export default class DownloadPdfRequestModel extends DownloadPdfRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
